module.exports = __webpack_public_path__ + "static/media/tokenomics-pie-chart-large.9bd33ecd.png";